import React from 'react';
import { useTimer } from 'react-timer-hook';

type StoreProps = {
  expiryTimestamp: Date;
};
const CountDown: React.FC<StoreProps> = (props) => {
  const { expiryTimestamp } = props;
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp,
    autoStart: true,
    onExpire: () => console.warn('onExpire called'),
  });

  return (
    <>
      <div className="count-down-container">
        <div className="count-container">
          <div className="value">
            <span>{days.toString().length === 1 ? '0' + days : days}</span>
            <span>:</span>
          </div>
          <span className="title">Day</span>
        </div>
        <div className="count-container">
          <div className="value">
            {hours.toString().length === 1 ? '0' + hours : hours}
            <span>:</span>
          </div>
          <span className="title">Hours</span>
        </div>
        <div className="count-container">
          <div className="value">
            {minutes.toString().length === 1 ? '0' + minutes : minutes}
            <span>:</span>
          </div>
          <span className="title">Minute</span>
        </div>
        <div className="count-container">
          <div className="value slv">
            {seconds.toString().length === 1 ? '0' + seconds : seconds}
          </div>
          <span className="title">Second</span>
        </div>
      </div>
    </>
  );
};

export default CountDown;
